import React, { useRef } from 'react';
import { HELP_TABS } from '../../../data/help';

export const HELP_PANEL_ID = 'help-panel';
export const getHelpTabId = (tab) => `help-tab-${tab}`;

const HelpTabs = ({ activeTab, onChange }) => {
  const tabRefs = useRef([]);
  const activeIndex = Math.max(0, HELP_TABS.findIndex(tab => tab.id === activeTab));

  const moveTo = (index) => {
    const next = (index + HELP_TABS.length) % HELP_TABS.length;
    onChange(HELP_TABS[next].id);
    tabRefs.current[next]?.focus();
  };

  const handleKeyDown = (event) => {
    const keyMoves = {
      ArrowRight: activeIndex + 1,
      ArrowLeft: activeIndex - 1,
      Home: 0,
      End: HELP_TABS.length - 1,
    };
    if (!(event.key in keyMoves)) return;
    event.preventDefault();
    moveTo(keyMoves[event.key]);
  };

  return (
    <div className="help-tabs">
      <div className="help-tabs__list" role="tablist" aria-label="고객센터 메뉴" onKeyDown={handleKeyDown}>
        {HELP_TABS.map((tab, index) => {
          const selected = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              ref={(node) => { tabRefs.current[index] = node; }}
              type="button"
              role="tab"
              id={getHelpTabId(tab.id)}
              aria-selected={selected}
              aria-controls={HELP_PANEL_ID}
              tabIndex={selected ? 0 : -1}
              className={`help-tabs__tab${selected ? ' help-tabs__tab--active' : ''}`}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HelpTabs;
